import angular from 'angular';
import { Subscription } from 'rxjs';
import { CapabilityIdEnum } from 'src/app/shared/capabilities-and-permissions';
import { DayRangeSelector, MonthRangeSelector } from './selectors-classes';

MetricController.$inject = [
  '$scope',
  'metric',
  'StrategiesFactory',
  'AlertingFactory',
  'TopToolbarFactory',
  '$translate',
  '$stateParams',
  '$filter',
  'MetricsFactory',
  'company',
  'LocalStorageFactory',
  'loggedUser',
  'scenarios',
  'MetricsHelperFactory',
  '$mdDialog',
  'DateRangePickerDialogFactory',
  '$timeout',
  'sites',
  'sitesMap',
  'roles',
  'customEvents',
  'MediasFactory',
  'routingTagsUsesAi',
  'usersForStats',
  'SelectorsFactory',
];
export function MetricController(
  $scope,
  metric,
  StrategiesFactory,
  AlertingFactory,
  TopToolbarFactory,
  $translate,
  $stateParams,
  $filter,
  MetricsFactory,
  company,
  LocalStorageFactory,
  loggedUser,
  scenarios,
  MetricsHelperFactory,
  $mdDialog,
  DateRangePickerDialogFactory,
  $timeout,
  sites,
  sitesMap,
  roles,
  customEvents,
  MediasFactory,
  routingTagsUsesAi,
  usersForStats,
  SelectorsFactory
) {

  $scope.selectTab = selectTab;
  $scope.subscriptions = new Subscription();

  const sortedTagGroups = angular.copy(company.tags_groups);
  sortedTagGroups.sort((t1, t2) => t1.display_order - t2.display_order);

  const sortedRoles = roles.sort((r1, r2) => {
    if (r1.name < r2.name) { return -1; }
    if (r1.name > r2.name) { return 1; }
    return 0;
  }).map(r => ({
    id: [r.id],
    name: r.name
  }));

  const sortedCustomEvents = customEvents.sort((ce1, ce2) => {
    if (ce1.name < ce2.name) { return -1; }
    if (ce1.name > ce2.name) { return 1; }
    return 0;
  }).map(ce => ({
    id: [ce.id],
    name: ce.name,
    event_type : ce.event_type
  }));


  function deleteStyles() {
    $scope.styles.forEach(style => {
      style.remove();
    });
  }
  function deleteStyle(id) {
    const style = document.getElementById(id);
    if (style) {
      style.remove();
    }
  }
  function addStyle(id, css) {
    deleteStyle(id);
    const style = document.createElement('style');
    style.type = 'text/css';
    style.id = id;
    style.appendChild(document.createTextNode(css));
    document.getElementsByTagName('head')[0].appendChild(style);
    $scope.styles.push(style);
  }
  $scope.styles = [];

  _listenQueriesSubmitted();

  $scope.$on("$destroy", () => {
    deleteStyles();
    $scope.subscriptions?.unsubscribe()
  });

  function submitQuery() {
    MetricsFactory.queriesWithThrottleTime$.next();
  }

  function selectTab(groupBy, g) {
    $scope.loading = true;
    groupBy.activate(g);
  }

  function _listenQueriesSubmitted() {
    $scope.subscriptions.add(
      MetricsFactory.queriesWithThrottleTime$.subscribe(() => {
        $scope.queryResponse = null;
        let filters = $scope.selectorsGroups.query();
        let groupBy = $scope.groupBy.query();
        MetricsFactory.createQuery(company.id, metric.id, { 'filters': filters, 'group_by': groupBy })
          .then(
            response => {
              function groupByCell(row) {
                let v = row['group-by'][0];
                if (v === null) {
                  return {
                    details: null,
                    bold: true,
                    name: $translate.instant('metrics/total')
                  };
                } else {
                  return {
                    details: null,
                    bold: false,
                    name: $scope.groupBy.selected.format(v)
                  };
                }
              }
              function groupByCompare(a, b) {
                let av = a['group-by'][0];
                let bv = b['group-by'][0];
                if (av === null && bv === null) {
                  return 0;
                } else if (av === null && bv !== null) {
                  return 1;
                } else if (av !== null && bv === null) {
                  return -1;
                } else {
                  return ($scope.groupBy.selected.value(av) < $scope.groupBy.selected.value(bv)) ? -1 : +1;
                }
              }
              function columnCell(row, column) {
                return {
                  column_key: column.key,
                  details: column.details(row),
                  name: column.value(row),
                  bold: column.bold || row['group-by'][0] === null,
                  hide: column.hide
                };
              }
              function getSuperHeaderTitle(superHeader) {
                function lpad(s) {
                  return ('00' + s).slice(-2);
                }
                let data;
                if (superHeader.type === 'tasks') {
                  let now = new Date();
                  data = $translate.instant('metrics/table-super-header/tasks/start') + ' ' + $filter('date')(now) + ' ' +
                    $translate.instant('metrics/table-super-header/tasks/middle') + ' ' +
                    lpad(now.getHours()) + ':' + lpad(now.getMinutes());
                  return data;
                } else if (superHeader.type === 'routing_tag') {
                  data = superHeader.translated_name;
                }
                return data;
              }
              function superHeader(superHeader, columns) {
                let show = !superHeader.hide_secondary_columns_on_init;
                let id = columns.map(c => c.key).join('-');
                function update(show) {
                  if (show) {
                    header.width = columns.length;
                    deleteStyle(id);
                  } else {
                    header.width = 1;
                    let cssSelectors = columns.slice(1).map(column => {
                      return `td.column_class_${column.key},th.column_class_${column.key}`;
                    });
                    let cssRule = cssSelectors.join(',') + '{display:none;}';
                    addStyle(id, cssRule);
                  }
                  return show;
                }
                let header = {
                  width: columns.length,
                  click: function () { show = update(!show); },
                  data: getSuperHeaderTitle(superHeader)
                }
                show = update(show); // initialize
                return header;
              }

              function superHeaders(superHeaders, columns) {
                if (angular.isUndefined(superHeaders) || superHeaders === null) {
                  return [];
                }
                let retval = [];
                let i = 0; // start of super column
                let j = 0; // end of super column
                while (i < columns.length && j < superHeaders.length) {
                  let c = columns[i];
                  if (c.key === superHeaders[j].start) {
                    let k = i; // k is the end-of-super-header column
                    while (c.key !== superHeaders[j].end) {
                      k++;
                      c = columns[k];
                    }
                    retval.push(superHeader(superHeaders[j], columns.slice(i, k + 1)));
                    i = k + 1;
                    j++;
                  } else {
                    retval.push({
                      width: 1,
                      click: () => { },
                      data: undefined
                    });
                    i++;
                  }
                }
                return retval;
              }
              function header(columns) {
                let retval = [];
                let previous = null;
                for (let c of columns) {
                  const frontColumn = {
                    name: c.header(),
                    tooltip: c.tooltip(),
                    boundary: false,
                    c: c
                  };
                  if (previous !== null) {
                    frontColumn.boundary = c.group !== null && (previous === null || previous.group !== c.group);
                  }
                  retval.push(frontColumn);

                  previous = c;
                }
                return retval;
              }
              function createGraphColumns(groupBy, columns, headers, columnsChanged) {
                function maxGraphColumns() {
                  let graphType = groupBy.graphs.selected.id;
                  if (graphType === 'pie') {
                    return 1;
                  } else if (graphType === 'vbars') {
                    return 3;
                  } else if (graphType === 'line') {
                    return 8;
                  }
                }
                // max 8 entries
                let colorPalette = ['#438bf8', '#ffa729', '#50c0f7', '#f67b70', '#b767c6', '#ee6290', '#ffd250', '#4dac50'];
                let availableColors = colorPalette.concat([]);
                let key = 'company-' + company.id + '-metric-' + metric.id + '-group-by-' + groupBy.name;
                function isSelected(c) {
                  return self.items.filter(i => c.key === i.key).length > 0;
                }
                function load() {
                  availableColors = colorPalette.concat([]);
                  let value = LocalStorageFactory.getItem(key);
                  if (value === null) {
                    self.items = columns.filter(c => c.is_default);
                    if (self.items.length === 0) {
                      self.items = columns.slice(0, 1);
                    }
                  } else {
                    self.items = columns.filter(c => value.indexOf(c.key) !== -1);
                  }
                  self.items = self.items.slice(0, maxGraphColumns());
                  for (let c of columns) {
                    if (isSelected(c)) {
                      c.color = availableColors.pop();
                      if (c.showAssociatedColumns) {
                        c.showAssociatedColumns();
                      }
                    } else {
                      c.color = null;
                      if (c.hideAssociatedColumns) {
                        c.hideAssociatedColumns();
                      }
                    }
                  }
                }
                function save() {
                  LocalStorageFactory.setItem(key, self.items.map(c => c.key));
                }
                function select(c) {
                  if (angular.isUndefined(c)) {
                    return;
                  }
                  if (isSelected(c)) {
                    if (self.items.length > 1) {
                      self.items = self.items.filter(i => i.key !== c.key);
                      availableColors.push(c.color);
                      c.color = null;
                      columnsChanged();
                      if (c.hideAssociatedColumns) {
                        c.hideAssociatedColumns();
                      }
                    }
                  } else {
                    if (self.items.length < maxGraphColumns()) {
                      c.color = availableColors.pop();
                      self.items.push(c);
                    } else {
                      let old = self.items.pop();
                      self.items.push(c);
                      c.color = old.color;
                      old.color = null;
                    }
                    if (c.showAssociatedColumns) {
                      c.showAssociatedColumns();
                    }
                    columnsChanged();
                  }
                  save();
                }
                let self = {
                  items: [],
                  load: load,
                  save: save,
                  select: select
                };
                return self;
              }
              function createGraph(groupBy, columns) {
                function reload() {

                  function buildChartOptions(chartType, unitSet) {
                    let chartOptions = {};
                    if (chartType === 'line' || chartType === 'vbars') {
                      chartOptions = {
                        animation: false,
                        tooltips: {
                          position: 'nearest',
                          intersect: false
                        },
                        scales: {
                          xAxes: [{
                            gridLines: {
                              display: false
                            }
                          }]
                        }
                      };
                      chartOptions.scales.yAxes = [];

                      for (let unit of unitSet) {
                        let axis = {
                          id: 'axis-' + unit,
                          type: 'linear',
                          display: 'true',
                          position: 'left',
                          gridLines: { display: false },
                          ticks: {
                            beginAtZero: true
                          }
                        };

                        if (unit !== 'none' && unitSet.length > 1) {
                          axis.position = 'right';
                        }

                        if (unit === ('time')) {
                          axis.ticks.callback = function (value, index, values) {
                            return MetricsHelperFactory.formatHms(value);
                          };
                        }

                        if (unit === ('percent')) {
                          axis.ticks.callback = function (value, index, values) {
                            if(Math.max(...values) <= 1) {
                              // if no data, the scale is made between 0 and 1, with strange values like 0.20000000000001
                              return `${value.toFixed(1)} %`;
                            } else {
                              return `${value} %`;
                            }
                          };
                        }

                        chartOptions.scales.yAxes.push(axis);
                      }

                      if (unitSet.indexOf('time') !== -1) {
                        chartOptions.tooltips.callbacks = {
                          label: function (value, data) {
                            let res = value.yLabel;
                            if (data.datasets[value.datasetIndex].yAxisID === 'axis-time') {
                              res = MetricsHelperFactory.formatHms(value.yLabel);
                            }
                            return res;
                          }
                        };
                      }

                    }
                    else if (chartType === 'pie') {
                      chartOptions = {
                        animation: false
                      };
                      if (unitSet.length === 1 && unitSet[0] === 'time') {
                        chartOptions.tooltips = {
                          callbacks: {
                            label: function (tooltipItem, data) {
                              let index = tooltipItem.index;
                              return MetricsHelperFactory.formatHms(data.datasets[0].data[index]);
                            }
                          }
                        };
                      }
                    }

                    return chartOptions;
                  }

                  let resultData = $scope.queryResponse.result
                    .filter(row => row['group-by'][0] !== null)
                    .sort((a, b) => groupBy.value(a['group-by'][0]) - groupBy.value(b['group-by'][0]));
                  let data = [];
                  let series = [];
                  let units = [];
                  for (let c of columns.items) {
                    data.push(resultData.map(row => row[c.key]));
                    series.push(c.header());
                    units.push(c.unit || 'none');
                  }
                  let unitSet = [...new Set(units)];
                  $scope.chartLabels = resultData.map(row => groupByCell(row).name);
                  $scope.chartColors = columns.items.map(c => c.color);
                  let chartType = groupBy.graphs.selected.id;
                  $scope.chartOptions = buildChartOptions(chartType, unitSet);
                  if (chartType === 'line') {
                    $scope.chartType = 'line';
                    $scope.chartData = data;
                    $scope.chartSeries = series;
                    $scope.datasetOverride = units.map(u => ({ yAxisID: 'axis-' + u }));
                  } else if (chartType === 'vbars') {
                    $scope.chartType = 'bar';
                    $scope.chartData = data;
                    $scope.chartSeries = series;
                    $scope.datasetOverride = units.map(u => ({ yAxisID: 'axis-' + u }));
                  } else if (chartType === 'pie') {
                    $scope.chartType = 'pie';
                    $scope.chartData = data[0];
                    $scope.chartSeries = null;
                    $scope.datasetOverride = null;
                  }
                }
                let self = {
                  reload: reload
                };
                return self;
              }

              function updateTableRows(result) {
                result.sort(groupByCompare);
                $scope.table.rows = result.map(row => [groupByCell(row)].concat(columns.map(column => columnCell(row, column))));
              }

              function reloadTableAndGraph() {
                // Filtering inactive users
                if ($scope.inactiveFilter.isUserGroupBy) {
                  $scope.queryResponse = response.data;
                  if (!$scope.inactiveFilter.shouldDisplay) {
                    $scope.masterColumn = graphColumns.items[0];
                    $scope.queryResponse.result = response.data.result.filter(r => r[$scope.masterColumn.key]);
                    updateTableRows($scope.queryResponse.result);
                  }
                  else {
                    $scope.masterColumn = graphColumns.items[0]; //Still need to update column for checkbox label
                    $scope.queryResponse.result = $scope.queryResponse.initialResult;
                    updateTableRows($scope.queryResponse.result);
                  }
                }
                graph.reload();
              }

              $scope.reloadTableAndGraph = reloadTableAndGraph;
              let columns = createColumns(metric, response.data.columns);
              let headers = header(columns);
              let graphColumns = createGraphColumns($scope.groupBy.selected, columns, headers, reloadTableAndGraph);
              graphColumns.load();

              // Filtering inactive users
              $scope.inactiveFilter = {
                isUserGroupBy: $scope.groupBy.selected.id().type === 'user',
                shouldDisplay: true
              };
              $scope.masterColumn = null;
              if ($scope.inactiveFilter.isUserGroupBy) {
                $scope.masterColumn = graphColumns.items[0];
              }
              $scope.queryResponse = response.data;
              if (!$scope.metric.has_rollup) {
                $scope.queryResponse.result = response.data.result.filter(m => m['group-by'][0] !== null);
              }
              $scope.queryResponse.initialResult = $scope.queryResponse.result;
              let graph = createGraph($scope.groupBy.selected, graphColumns);
              $scope.table = {
                superHeaders: superHeaders(response.data.super_headers, columns),
                header: [{ boundary: false, name: $scope.groupBy.selected.name, tooltip: '' }].concat(headers),
                rows: [],
                graphColumns: graphColumns,
                graph: graph
              };

              updateTableRows($scope.queryResponse.result);
              graph.reload();
              $scope.selectorsGroups.save();
              $scope.groupBy.save();
              $scope.loading = false;
            },
            error => {
              $scope.loading = false;
              $scope.queryResponse = {}; // 2nd spinner is based on "!queryResponse", different from main spinner based on "loading"
              AlertingFactory.alertHTTPError(error);
            });
      }));
  }

  function createColumns(metric, columns) {

    function header(column) {
      if (column.is_name_translated) {
        return column.translated_name;
      }
      return $translate.instant('metrics/table-header/' + metric.internal_name + '/' + column.name);
    }

    function tooltip(column) {
      if (column.tooltip) {
        return column.tooltip;
      }
      let tname = 'metrics/tooltip/' + metric.internal_name + '/' + column.name;
      let tcontent = $translate.instant('metrics/tooltip/' + metric.internal_name + '/' + column.name);
      if (tname === tcontent) {
        return '';
      }
      return tcontent;
    }
    
    function key(column) {
      return (column.key !== undefined) ? column.key : column.name;
    }

    function detailsKey(column) {
      return (column.details_type === undefined) ? null : key(column);
    }

    function details(column, row) {
      let dk = detailsKey(column);
      if (column.details_type === undefined) {
        return null;
      }
      let v = row[key(column)];
      if (v === null || v === 0) {
        return null;
      }
      return { row_id: row['group-by'][0], cell_id: dk, query_id: $scope.queryResponse.query_id }
    }
    
    function integerColumn(column) {
      let k = key(column);
      return {
        group: column.group ? column.group : null,
        header: function () { return header(column); },
        tooltip: function () { return tooltip(column); },
        bold: column.bold ? column.bold : false,
        key: k,
        details: function (row) { return details(column, row) },
        unit: 'none',
        value: function (row) {
          return row[k];
        }
      };
    }

    function timestampDeltaColumn(column) {
      let k = key(column);
      return {
        group: column.group ? column.group : null,
        header: function () { return header(column); },
        tooltip: function () { return tooltip(column); },
        bold: column.bold ? column.bold : false,
        key: k,
        details: function (row) { return details(column, row) },
        unit: 'time',
        value: function (row) {
          return MetricsHelperFactory.formatHms(row[k]);
        }
      };
    }

    function floatColumn(column) {
      let k = key(column);
      return {
        group: column.group ? column.group : null,
        header: function () { return header(column); },
        tooltip: function () { return tooltip(column); },
        bold: column.bold ? column.bold : false,
        key: k,
        details: function (row) { return null; },
        unit: 'none',
        value: function (row) {
          if (row[k] === null) {
            return row[k];
          }
          let precision = (column.precision !== undefined) ? column.precision : 2;
          let factor = Math.pow(10, precision);
          return Math.round(row[k] * factor) / factor;
        }
      };
    }

    function percentageColumn(column) {
      let k = key(column);
      return {
        group: column.group ? column.group : null,
        header: function () { return header(column); },
        tooltip: function () { return tooltip(column); },
        bold: column.bold ? column.bold : false,
        key: k,
        details: function (row) { return details(column, row) },
        unit: 'percent',
        value: function (row) {
          return `${Math.round(row[k])} %`;
        }
      };
    }

    function createColumn(column) {
      switch(column.type) {
        case 'integer':
          return integerColumn(column);
        case 'timestamp_delta':
          return timestampDeltaColumn(column);
        case 'float':
          return floatColumn(column);
        case 'percentage':
          return percentageColumn(column);
        default:
          // if no default, crash UI for new column
          return integerColumn(column);
      }
    }
    
    return columns.map(createColumn);
  }

  function sitesAllowed(sites_criterias) {
    const criteriaFound = (sites_criterias || []).find(sites_criterias => sites_criterias?.type === 'sites_types');
    const siteTypesCriteria = criteriaFound?.values || [];

    var siteTypesSet = new Set();

    let sites = Object.keys(loggedUser.capabilities || {})
      .filter(siteId => {
        const siteHasCapability = loggedUser.capabilities[siteId]?.includes(CapabilityIdEnum.Statistics);
        if (!siteHasCapability) {
          return false;
        }
        const site = sitesMap.get(+siteId);
        siteTypesSet.add(site.type);
        return !siteTypesCriteria.length || siteTypesCriteria.includes(site.type)
      })
      .map(siteId => sitesMap.get(+siteId));

    return { sites, siteTypesSet };
  }

  function tasksTypesAllowed(criterias) {
    const criteriaFound = (criterias || []).find(criteria => criteria?.type === 'task_types')
    return criteriaFound?.values || [];
  }

  function localStorageKeyForVisibility(s) {
    return 'company-' + company.id + '-metric-' + metric.id + '-selector' + s.name + '-is-visible';
  }

  function createSelectorsGroups(metric) {
    function createSelectorGroup(sg) {
      function createSelectors(s) {
        // keep alphabetical order for better readability
        switch (s.type) {
          case 'account': {
            let { sites } = sitesAllowed(s['filters']);
            return SelectorsFactory.accountSelector(s, sites, company, metric);
          }
          case 'action-routing-tags':
            return SelectorsFactory.actionRoutingTagsSelector(s, sortedTagGroups, routingTagsUsesAi, company, metric);
          case 'bh_nbh':
            // not used
            return SelectorsFactory.hoHnoSelector(s, company, metric);
          case 'bot':
            // not used
            return SelectorsFactory.botSelector(s, company, metric);
          case 'custom-event':
            return SelectorsFactory.customEventSelector(s, sortedCustomEvents, company, metric);
          case 'custom-field':
            return SelectorsFactory.customFieldSelector(s, company, metric);
          case 'dayrange':
            if (s.mode === 'month') {
              return [new MonthRangeSelector(company, metric, LocalStorageFactory, MetricsFactory, $filter, $translate).create(s)];
            } else {
              return [new DayRangeSelector(company, metric, DateRangePickerDialogFactory, LocalStorageFactory, MetricsFactory, $filter, $translate).create(s)];
            }
          case 'enum':
            // not used
            return SelectorsFactory.enumSelector(s, company, metric);
          case 'human_or_bot':
            return SelectorsFactory.humanOrBotSelector(s, company, metric);
          case 'human':
            // not used
            return SelectorsFactory.humanSelector(s, company, metric);
          case 'incoming-team-tags':
            return SelectorsFactory.incomingRoutingTagsSelector(s, sortedTagGroups, routingTagsUsesAi, company, metric);
          case 'linked-to-crm-yes-no':
            return SelectorsFactory.linkedToCrmSelector(s, company, metric);
          case 'manual-or-automatic':
            return SelectorsFactory.manualOrAutomaticSelector(s, company, metric);
          case 'qr-scenario': {
            if ($scope.careScenarios.length === 0) {
              $scope.error = 'metrics/qr/error/no-active';
              return [];
            }
            return SelectorsFactory.qrScenarioSelector(s, $scope.careScenarios, sites, company, metric);
          }
          case 'roles':
            return SelectorsFactory.rolesSelector(s, sortedRoles, company, metric);
          case 'scenarios':
            return SelectorsFactory.scenarioSelector(s, ['quick-reply', 'marketing'], sites, $scope.careScenarios, $scope.surveyScenarios, $scope.marketingScenarios, company, metric);
          case 'survey-scenario':
            return SelectorsFactory.surveyScenarioSelector(s, $scope.surveyScenarios, sites, company, metric);
          case 'tags':
            return SelectorsFactory.tagsSelectors(s, sortedTagGroups, routingTagsUsesAi, company, metric);
          case 'task_type': {
            // channel
            const { siteTypesSet } = sitesAllowed(s['filters']);
            const allowedTaskTypes = tasksTypesAllowed(s['filters']);
            return SelectorsFactory.taskTypeSelector(s, siteTypesSet, allowedTaskTypes, company, metric);
          }
          case 'time-to-answer-survey':
            return SelectorsFactory.timeToAnswerSurveySelector(s, company, metric);
          case 'user-team':
            return SelectorsFactory.userTeamSelector(s, sortedTagGroups, routingTagsUsesAi, company, metric);
          case 'user':
            return SelectorsFactory.userSelector(s, usersForStats, company, metric);
          default:
            return null;
        }
      }

      function selectorsWithValues() {
        return self.selectors.filter(s => s.hasValue());
      }

      let self = {
        name: $translate.instant('metrics/' + metric.internal_name + '/' + sg.name),
        selectors: sg.selectors.map(createSelectors).reduce(function (acc, i) {
          return i ? acc.concat(i) : acc;
        }, []),
        selectorsWithValues: selectorsWithValues
      };

      return self;
    }

    function selectors() {
      return self.groups.map(g => g.selectors).reduce(function (acc, i) { return acc.concat(i); }, []);
    }
    function selectorsWithValues() {
      return self.groups.map(g => g.selectorsWithValues()).reduce(function (acc, i) { return acc.concat(i); }, []);
    }
    function load() {
      self.selectors().forEach(s => s.load());
    }
    function selectedCriteriaForXls() {
      return self.selectorsWithValues().reduce((acc, s) => acc.concat([s.selectedCriteriaForXls()]), []);
    }

    function loadFromReport(selectedReport, reportDate) {
      self.loading = true;
      self.selectors().forEach(s => s.loadFromReport(selectedReport, reportDate));
      self.loading = false;
    }
    function save() {
      self.selectors().forEach(s => s.save());
    }
    function removeSelectedCriteriaOnClick() {
      self.selectors().forEach(s => s.remove());
      submitQuery();
    }
    function query(options) {
      let retval = {};
      for (let s of self.selectorsWithValues()) {
        if (options && ((options.skipDayRanges && s.type === 'dayrange') || options.skipMonthRanges && s.type === "monthrange")) {
          continue;
        }
        let q = s.query();
        for (let where in q) {
          if (retval.hasOwnProperty(where)) {
            retval[where].push(q[where]);
          } else {
            retval[where] = [q[where]];
          }
        }
      }
      return retval;
    }
    function initVisibilitiesFromLocalStorage() {
      self.selectors().filter(s => !s.isMandatory).forEach((s, index) => {
        let localStorageValue = LocalStorageFactory.getItem(localStorageKeyForVisibility(s));
        if (localStorageValue !== null) {
          s.isDisplayed = localStorageValue;
        }
      });
    }
    function maybeDisableMoreCriteriaButtons() {
      // If all selectors are visible by default, let's not show the "more criteria" button
      // Note that this should be called *before* initVisibilitiesFromLocalStorage, load or loadFromReport !
      if (self.selectors().length == self.selectors().filter(s => s.isDisplayed).length) {
        self.isCriteriaVisibilityButton = false;
      }
    }
    function maybeDisableResetAllCriteriaButtons() {
      // If all selectors are mandatory, let's disable the "reset" button
      if (self.selectors().length == self.selectors().filter(s => s.isMandatory).length) {
        self.isCriteriaResetButton = false;
      }
    }
    function saveVisibilitiesToLocalStorage() {
      self.selectors().filter(s => !s.isMandatory).forEach((s, index) => {
        LocalStorageFactory.setItem(localStorageKeyForVisibility(s), s.isDisplayed ? true : false);
      });
    }
    function showCriteriaVisibilityDialog(event) {
      $mdDialog.show({
        template: require('./criteria-visibility.dialog.html'),
        targetEvent: event,
        locals: {
          selectorsGroups: self,
        },
        controller: 'CriteriaVisibilityController'
      })
    }

    let self = {
      groups: metric.selectors_groups.map(sg => createSelectorGroup(sg)),
      selectors: selectors,
      selectorsWithValues: selectorsWithValues,
      showCriteriaVisibilityDialog: showCriteriaVisibilityDialog,
      isCriteriaVisibilityButton: true,
      isCriteriaResetButton: true,
      maybeDisableMoreCriteriaButtons: maybeDisableMoreCriteriaButtons,
      maybeDisableResetAllCriteriaButtons: maybeDisableResetAllCriteriaButtons,
      initVisibilitiesFromLocalStorage: initVisibilitiesFromLocalStorage,
      saveVisibilitiesToLocalStorage: saveVisibilitiesToLocalStorage,
      submitQuery: submitQuery,
      load: load,
      save: save,
      removeSelectedCriteriaOnClick: removeSelectedCriteriaOnClick,
      selectedCriteriaForXls: selectedCriteriaForXls,
      query: query,
      loadFromReport: loadFromReport
    };

    return self;
  }


  function groupByGraphs(graphs, graphChanged) {
    let items = graphs.map(g => ({
      id: g,
      name: $translate.instant('metrics/graphs/' + g)
    }));
    function load(extra) {
      let previous = self.items.filter(i => i.id === extra);
      if (previous.length === 0) {
        self.selected = self.items[0];
      } else {
        self.selected = previous[0];
      }
    }
    function save() {
      return self.selected.id;
    }
    let self = {
      items: items,
      selected: null,
      change: graphChanged,
      load: load,
      save: save
    };
    return self;
  }
  function createGroupByTimestamp(i, graphChanged) {
    function query() {
      function value(item) {
        return { type: 'timestamp', subtype: item, timestamp_field: i.timestamp_field, account_field: i.account_field };
      }
      return value(self.selected.value);
    }
    function matchesQuery(q) {
      return q.type === 'timestamp' && q.timestamp_field === i.timestamp_field;
      // the 'account_field' property in the query() method above is used in MetricsQuery.py
      // to figure out which account will be used to calculate the business hours;
      // hence we don't need to use it here
    }
    function load(extra) {
      let selected = self.items.filter(j => j.value === extra);
      if (selected.length > 0) {
        self.selected = selected[0];
      } else {
        self.selected = self.items[0];
      }
    }
    function save() {
      if (self.selected !== null) {
        return self.selected.value;
      } else {
        return null;
      }
    }
    function change(i) {
      submitQuery();
    }
    function id() {
      return i;
    }
    function yearMonth(year, month) {
      return $translate.instant('month/short/' + parseInt(month)) + ', ' + year;
    }
    function dayOfWeek(day) {
      let dayToString = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
      return $translate.instant(dayToString[day - 1]);
    }
    function format(v) {
      if (self.selected.value === 'year-month-day') {
        let values = v.split('-');
        return $filter('date')(new Date(values[0], values[1] - 1, values[2]));
      } else if (self.selected.value === 'year-month') {
        let values = v.split('-');
        return yearMonth(values[0], values[1]);
      } else if (self.selected.value === 'day-of-week') {
        return dayOfWeek(v);
      } else if (self.selected.value === 'day-of-week-hour-of-day') {
        let values = v.split('-');
        return dayOfWeek(values[0]) + ' ' + values[1] + $translate.instant('hour_short');
      } else if (self.selected.value === 'hour-of-day') {
        return v + $translate.instant('hour_short');
      } else if (self.selected.value === 'business-hours') {
        return $translate.instant('metrics/group-by/' + v);
      }
    }
    function getValue(v) {
      if (self.selected.value === 'year-month-day') {
        let values = v.split('-');
        return new Date(values[0], values[1] - 1, values[2]);
      } else if (self.selected.value === 'year-month') {
        let values = v.split('-');
        return new Date(values[0], values[1] - 1, 1);
      } else if (self.selected.value === 'day-of-week') {
        return parseInt(v);
      } else if (self.selected.value === 'day-of-week-hour-of-day') {
        let values = v.split('-');
        return parseInt(values[0]) * 24 + parseInt(values[1]);
      } else if (self.selected.value === 'hour-of-day') {
        return parseInt(v);
      } else if (self.selected.value === 'business-hours') {
        return v;
      }
    }
    let items = i.items ? i.items : ['year-month-day', 'year-month', 'hour-of-day'];
    let self = {
      name: $translate.instant('metrics/group-by/' + metric.internal_name + '/' + i.name),
      isOpen: false,
      selected: null,
      items: items.map(j => ({
        name: $translate.instant('metrics/group-by-timestamp/' + j),
        value: j
      })),
      change: change,
      id: id,
      query: query,
      matchesQuery: matchesQuery,
      load: load,
      save: save,
      value: getValue,
      format: format,
      graphs: groupByGraphs(['line', 'vbars'], graphChanged)
    };
    return [self];
  }
  function createGroupByUser(i, graphChanged) {
    let name = i.name ? i.name : 'user';
    let usersById = {};
    for (let user of company.users) {
      usersById[user.id] = user.realname;
    }
    function query() {
      let query = { type: 'field', field: 'user' };
      query.values = (company.users || []).map(user => {
        if ((i.human_users && user.appear_in_dropdown && !user.is_bot) || (!i.human_users && user.appear_in_dropdown)) {
          return user.id;
        }
      });
      return query;
    }
    function matchesQuery(q) {
      return q.type === 'field' && q.field === 'user';
    }
    function id() {
      return i;
    }
    function format(v) {
      if (!(v in usersById)) {
        console.log(name + ' (user) ' + v + ' not found');
      }
      return usersById[v];
    }
    let self = {
      name: $translate.instant('metrics/group-by/' + metric.internal_name + '/' + name),
      id: id,
      query: query,
      matchesQuery: matchesQuery,
      load: function (extra) { },
      save: function () { },
      value: format,
      format: format,
      graphs: groupByGraphs(['vbars', 'pie'], graphChanged)
    };
    return [self];
  }
  function createGroupByScenario(i, graphChanged, flavors) {
    let allScenariosWithInputFlavor = [];

    for (let flavor of flavors) {
      if (flavor === 'quick-reply') {
        allScenariosWithInputFlavor = allScenariosWithInputFlavor.concat($scope.careScenarios)
      }
      else if (flavor === 'survey') {
        allScenariosWithInputFlavor = allScenariosWithInputFlavor.concat($scope.surveyScenarios)
      }
      else if (flavor === 'marketing') {
        allScenariosWithInputFlavor = allScenariosWithInputFlavor.concat($scope.marketingScenarios)
      }
    }
    let name = i.name ? i.name : 'scenarios';
    let scenariosById = {};
    for (let scenario of allScenariosWithInputFlavor) {
      scenariosById[scenario.id] = scenario.name;
    }
    function query() {
      return { type: 'field', field: 'scenarios', values: allScenariosWithInputFlavor.map(s => s.id) };
    }
    function matchesQuery(q) {
      return q.type === 'field' && q.field === 'scenarios';
    }
    function id() {
      return i;
    }
    function format(v) {
      if (!(v in scenariosById)) {
        console.log(name + ' (scenario) ' + v + ' not found');
      }
      return scenariosById[v];
    }
    let self = {
      name: $translate.instant('metrics/group-by/' + metric.internal_name + '/' + name),
      id: id,
      query: query,
      matchesQuery: matchesQuery,
      load: function (extra) { },
      save: function () { },
      value: format,
      format: format,
      graphs: groupByGraphs(['vbars', 'pie'], graphChanged)
    };
    return [self];
  }

  function createGroupByCustomEvent(i, graphChanged) {
    let name = i.name ? i.name : 'custom-event';
    let customEventById = {};
    for (let ce of sortedCustomEvents) {
      customEventById[ce.id] = ce.name;
    }
    function query() {
      return { type: 'field', field: 'custom_event', values: sortedCustomEvents.map(u => u.id) };
    }
    function matchesQuery(q) {
      return q.type === 'field' && q.field === 'custom_event';
    }
    function id() {
      return i;
    }
    function format(v) {
      if (!(v in customEventById)) {
        console.log(name + ' (custom event) ' + v + ' not found');
      }
      return customEventById[v];
    }
    let self = {
      name: $translate.instant('metrics/group-by/' + metric.internal_name + '/' + name),
      id: id,
      query: query,
      matchesQuery: matchesQuery,
      load: function (extra) { },
      save: function () { },
      value: format,
      format: format,
      graphs: groupByGraphs(['vbars', 'pie'], graphChanged)
    };
    return [self];
  }

  function createGroupByCustomField(groupBy, graphChanged) {
    if(!(metric.extra_data?.customFieldValues && metric.extra_data.customFieldValues[groupBy.name])) {
      return null;
    }

    function query() {
      return { type: 'field', field: groupBy.name, values: metric.extra_data.customFieldValues[groupBy.name], displayName: groupBy.display_name };
    }

    function matchesQuery(q) {
      return q.type === 'field' && q.field === groupBy.name;
    }

    function id() {
      return groupBy;
    }

    function format(v) {
      if (v === 'group-by-none-value') {
        return $translate.instant('metrics/group-by/no-data');
      } else {
        return v;
      }
    }

    let self = {
      name: groupBy.display_name || 'custom-field',
      id: id,
      query: query,
      matchesQuery: matchesQuery,
      load: function (extra) { },
      save: function () { },
      value: format,
      format: format,
      graphs: groupByGraphs(['vbars', 'pie'], graphChanged)
    };

    return [self];
  }

  function createGroupByCrmOrganization(i, graphChanged) {
    function query() {
      return { type: 'field', field: 'crm_link', values: ['group-by-none-value', 1] }; // 'group-by-none-value': not linked, 1: linked
    }
    function matchesQuery(q) {
      return q.type === 'field' && q.field === 'crm_link';
    }
    function id() {
      return i;
    }
    function format(v) {
      if (v === 'group-by-none-value') {
        return $translate.instant('no');
      } else {
        return $translate.instant('yes');
      }
    }
    let self = {
      name: $translate.instant('metrics/user_linked_to_crm'),
      id: id,
      query: query,
      matchesQuery: matchesQuery,
      load: function () { },
      save: function () { },
      value: format,
      format: format,
      graphs: groupByGraphs(['vbars', 'pie'], graphChanged)
    };
    return [self];
  }
  function createGroupByTag(field, tagGroup, graphChanged) {
    // XXX: there may be 2 team selectors in stats page, if it exists the one that should be displayed by default is "Team" (team value on action date)
    // while the other one "Team (message tag)" (team value now) has to be hidden.
    let tagGroupName = tagGroup.name;
    if (field === 'action_routing_tag' && tagGroup.is_routing === 1) {
      tagGroupName = $translate.instant('metrics/routing_tag_on_action');
    } else if (field === 'incoming_team_tag' && tagGroup.is_routing === 1) {
      tagGroupName = $translate.instant('metrics/incoming-team-tag');
    } else if (tagGroup.is_routing === 1) {
      tagGroupName = $translate.instant('metrics/routing_tag_now');
    }
    let tagsById = {};
    for (let tag of tagGroup.tags) {
      tagsById[tag.id] = tag;
    }
    function query() {
      return { type: 'field', field: field, values: tagGroup.tags.map(t => t.id) };
    }
    function matchesQuery(q) {
      return q.type === 'field' && q.field === field;
    }
    function id() {
      return 'tg-' + tagGroup.id;
    }
    function format(v) {
      if (!(v in tagsById)) {
        console.log(tagGroupName + ' (tag) ' + v + ' not found');
        // SF 6076 : Tag was deleted.
        // Tags come from /self endpoint call which formats company.tag_groups and filters out deleted tags.
        // This endpoint called once and the result is used almost everywhere in the platform.
        // As a result, we can not remove the filter on active tags only.
        // We can set up a new endpoint tag fetch all the tags but metrics controller is generic to all stats page.
        return $translate.instant('metrics/tags/deleted', { 'tag_id': v });
      }
      return tagsById[v].name;
    }
    let self = {
      name: tagGroupName,
      id: id,
      query: query,
      matchesQuery: matchesQuery,
      load: function () { },
      save: function () { },
      format: format,
      value: format,
      graphs: groupByGraphs(['vbars', 'pie'], graphChanged)
    };
    return self;
  }
  function createGroupByTags(i, graphChanged) {
    return sortedTagGroups.map(tg => createGroupByTag('task_tag_' + (tg.tag_index + 1), tg, graphChanged));
  }
  function createGroupByIncomingRoutingTags(i, graphChanged) {
    return sortedTagGroups.filter(tg => tg.is_routing).map(tg => createGroupByTag('incoming_team_tag', tg, graphChanged));
  }
  function createGroupByActionRoutingTags(i, graphChanged) {
    return sortedTagGroups.filter(tg => tg.is_routing).map(tg => createGroupByTag('action_routing_tag', tg, graphChanged));
  }
  function createGroupByTaskType(i, graphChanged) {
    let field = i.field ? i.field : 'task_type';
    let { sites } = sitesAllowed();
    let task_type = {};
    for (let st of StrategiesFactory.getAll()) {
      for (let site of sites) {
        if (site.type === st.getType()) {
          for (let tt of st.getAllTasksTypesForSearchAndMetrics()) {
            task_type[tt] = $translate.instant('task/' + st.getTaskTypeString(tt));
          }
        }
      }
    }
    function id() {
      return 'task_type';
    }
    function query() {
      return { type: 'field', field: field, values: Object.keys(task_type) };
    }
    function format(v) {
      return task_type[v];
    }
    function matchesQuery(q) {
      return q.type === 'field' && q.field === field;
    }
    let self = {
      name: $translate.instant('metrics/group-by/task_type'),
      id: id,
      query: query,
      matchesQuery: matchesQuery,
      load: function () { },
      save: function () { },
      format: format,
      value: format,
      graphs: groupByGraphs(['vbars', 'pie'], graphChanged)
    };
    return self;
  }
  function createGroupByAccount(i, graphChanged) {
    let field = i.field ? i.field : 'account';
    let { sites } = sitesAllowed();
    let sitesById = {};
    for (let site of sites) {
      sitesById[site.id] = site;
    }
    function id() {
      return 'account';
    }
    function query() {
      return { type: 'field', field: 'account', values: sites.map(s => s.id) };
    }
    function matchesQuery(q) {
      return q.type === 'field' && q.field === 'account';
    }
    function format(v) {
      if (!(v in sitesById)) {
        console.log(field + ' (site) ' + v + ' not found');
      }
      return sitesById[v].name;
    }
    let self = {
      name: $translate.instant('metrics/group-by/account'),
      id: id,
      query: query,
      matchesQuery: matchesQuery,
      load: function () { },
      save: function () { },
      format: format,
      value: format,
      graphs: groupByGraphs(['vbars', 'pie'], graphChanged)
    };
    return self;
  }
  function createGroupBy(metric, graphChanged) {
    function createGroupByItems(i) {
      // keep alphabetical order for better readability
      switch (i.type) {
        case 'account':
          return createGroupByAccount(i, graphChanged);
        case 'action-routing-tags':
          return createGroupByActionRoutingTags(i, graphChanged);
        case 'custom-event':
          return createGroupByCustomEvent(i, graphChanged);
        case 'custom-field':
          return createGroupByCustomField(i, graphChanged);
        case 'incoming-team-tag':
          return createGroupByIncomingRoutingTags(i, graphChanged);
        case 'linked-to-crm-yes-no':
          return createGroupByCrmOrganization(i, graphChanged);
        case 'scenarios':
          return createGroupByScenario(i, graphChanged, ['quick-reply', 'marketing']);
        case 'tags':
          return createGroupByTags(i, graphChanged);
        case 'task_type':
          return createGroupByTaskType(i, graphChanged);
        case 'timestamp':
          return createGroupByTimestamp(i, graphChanged);
        case 'user':
          return createGroupByUser(i, graphChanged);
        default:
          return null;
      }
    }

    let key = 'company-' + company.id + '-metric-' + metric.id + '-group-by';
    function defaultValue() {
      let defaultItems = self.items.filter(i => i.is_default);
      if (defaultItems.length === 0) {
        return self.items[0];
      } else {
        return defaultItems[0];
      }
    }
    function load() {

      let v = LocalStorageFactory.getItem(key);
      let selected = null;
      if (v === null) {
        selected = defaultValue();
        selected.load(null);
        selected.graphs.load(null);
      } else {
        let savedItems = self.items.filter(i => angular.equals(i.id(), v.id));
        if (savedItems.length === 0) {
          selected = defaultValue();
          selected.load(null);
          selected.graphs.load(null);
        } else {
          selected = savedItems[0];
          selected.load(v.extra);
          selected.graphs.load(v.graph);
        }
      }
      self.selected = selected;
    }
    function loadFromReport(selectedReport, reportDate) {
      if (selectedReport) {
        let group_by = selectedReport.group_by;
        let savedItems = self.items.filter(i => i.matchesQuery(group_by));
        if (savedItems.length > 0) {
          self.selected = savedItems[0];
          self.selected.load(group_by.subtype); // subtype is only defined when grouping by a timestamp field
          self.selected.graphs.load(null); // graph type is not stored in the report
        } else {
          self.selected = defaultValue();
          self.selected.load(null);
          self.selected.graphs.load(null);
        }
      }
    }
    function save() {
      LocalStorageFactory.setItem(key, {
        id: self.selected.id(),
        extra: self.selected.save(),
        graph: self.selected.graphs.save()
      });
    }
    function query() {
      return self.selected.query();
    }
    function activate(g) {
      // We use a couple of timeout so that the tab scrolling animation looks smooth
      // and to prevent flashing content in the tab panes when the new data is available
      $timeout(() => {
        $scope.queryResponse = null;
        $timeout(() => {
          self.selected = g;
          self.isOpen = false;
          self.selected.load(null);
          self.selected.graphs.load(null);
          submitQuery();
        }, 50);
      }, 300);
    }

    let items = metric.group_by.map(createGroupByItems).reduce(function (acc, i) {
      return i ? acc.concat(i) : acc;
    }, []);

    if (items.length > 6) {
      for (let i = 5; i < items.length; i++) {
        items[i].isDropdown = true;
      }
    }

    let self = {
      selected: null,
      items: items,
      query: query,
      load: load,
      save: save,
      activate: activate,
      loadFromReport: loadFromReport
    };
    return self;
  }

  function exportXls() {
    $scope.loading = true;
    MetricsFactory.createExport(company.id, metric.id, $scope.queryResponse.query_id, {
      table: $scope.table,
      filters: $scope.selectorsGroups.selectedCriteriaForXls(),
      group_by: $scope.groupBy,
    }).then(response => {
      const { content, content_type, content_filename } = response.data
      MediasFactory.downloadBinaryBase64(content, content_type, content_filename);
      $scope.loading = false;
    }, () => {
      AlertingFactory.httpErrorHandler();
      $scope.loading = false;
    });
  }

  function exportDetailsXls(details) {
    if (details === null) {
      return;
    }
    $scope.loading = true;
    MetricsFactory.createDetailsExport(company.id, metric.id, $scope.queryResponse.query_id, details, 'json').then(
      function (response) {
        $scope.loading = false;
        const query_id = $scope.queryResponse.query_id

        return $mdDialog.show({
          template: require('./export-details.html'),
          fullscreen: true,
          resolve: {
            data: function () {
              return response.data;
            }
          },
          controller: ['$scope', 'data', '$mdDialog', function ($scope, data, $mdDialog) {
            $scope.data = data;
            $scope.close = function () { $mdDialog.hide(); };
            $scope.export = () => {
              MetricsFactory.createDetailsExport(company.id, metric.id, query_id, details, 'xlsx').then(response => {
                const { content, content_type, content_filename } = response.data;
                MediasFactory.downloadBinaryBase64(content, content_type, content_filename);
              }, AlertingFactory.httpErrorHandler());
            };
          }]
        });
      }, function (response) {
        $scope.loading = false;
        if (response.status === 400 && response.data.error.reason === 'too-many-ids') {
          let alert = $mdDialog.alert({
            title: $translate.instant('metrics/details/dialog/title'),
            textContent: $translate.instant('metrics/details/dialog/too-many-ids'),
            ok: $translate.instant('close')
          });
          $mdDialog.show(alert);
        }
        // XXX: display error notification.
      });
  }

  /*
   * Inits a report object from the current metric, filters and group by,
   * opens the report edition dialog in creation mode,
   * and saves the report if the user closes the dialog with the save button
   */
  function createReport(event) {
    let reportName = `${metric.title || metric.name || ''} ${$translate.instant('metrics/group-by/per')} ${$scope.groupBy.selected.name}`;
    
    if ($scope.groupBy.selected.selected) {
      reportName += ` (${$scope.groupBy.selected.selected.name})`;
    }

    let report = {
      'metric_id': metric.id,
      'filters': $scope.selectorsGroups.query({ 'skipDayRanges': true, 'skipMonthRanges': true }),
      'group_by': $scope.groupBy.query(),
      'name': reportName,
      'send_by': {
        'email': true,
        'ftp': false
      },
      'created_for_users': [loggedUser.id]
    }

    $mdDialog.show({
      controller: [
        '$scope',
        ($scope) => {
          $scope.data = {
            componentName: 'ReportEditionMetricDialogComponent',
            dialogTitle : $translate.instant('metric-reports/edition/create-title'),
            report: angular.copy(report),
            sites: sites,
            roles: roles,
            scenarios: scenarios,
            customEvents: customEvents,
            metric: metric,
            isCreation: true,
          }
          $scope.cancelDialog = $mdDialog.cancel;
          $scope.hideDialog = $mdDialog.hide;
        }
      ],
      template: `<angular-metrics-dialog-container-for-ajs
  [data]="data"
  (hide-dialog)="hideDialog($event)"
  (cancel-dialog)="cancelDialog()"
  ></angular-metrics-dialog-container-for-ajs>`,
      targetEvent: event
    })
  }

  function _graphChangedCallback() {
    if ($scope.queryResponse) {
      $scope.table.graphColumns.load();
      $scope.table.graph.reload();
      $scope.groupBy.save();
    }
  }

  function subGroupBySelected(subItem, groupByItem) {
    // let's give a headstart to the fab-toolbar close animation
    $timeout(() => {
      groupByItem.selected = subItem;
      groupByItem.change(subItem);
    }, 300);
  }

  function graphTypeSelected(graphItem, groupByItem) {
    groupByItem.graphs.selected = graphItem;
    groupByItem.graphs.change();
  }

  /*
       IIIIIIIIII     NNNNNNNN        NNNNNNNN     IIIIIIIIII     TTTTTTTTTTTTTTTTTTTTTTT
       I::::::::I     N:::::::N       N::::::N     I::::::::I     T:::::::::::::::::::::T
       I::::::::I     N::::::::N      N::::::N     I::::::::I     T:::::::::::::::::::::T
       II::::::II     N:::::::::N     N::::::N     II::::::II     T:::::TT:::::::TT:::::T
         I::::I       N::::::::::N    N::::::N       I::::I       TTTTTT  T:::::T  TTTTTT
         I::::I       N:::::::::::N   N::::::N       I::::I               T:::::T
         I::::I       N:::::::N::::N  N::::::N       I::::I               T:::::T
         I::::I       N::::::N N::::N N::::::N       I::::I               T:::::T
         I::::I       N::::::N  N::::N:::::::N       I::::I               T:::::T
         I::::I       N::::::N   N:::::::::::N       I::::I               T:::::T
         I::::I       N::::::N    N::::::::::N       I::::I               T:::::T
         I::::I       N::::::N     N:::::::::N       I::::I               T:::::T
       II::::::II     N::::::N      N::::::::N     II::::::II           TT:::::::TT
       I::::::::I     N::::::N       N:::::::N     I::::::::I           T:::::::::T
       I::::::::I     N::::::N        N::::::N     I::::::::I           T:::::::::T
       IIIIIIIIII     NNNNNNNN         NNNNNNN     IIIIIIIIII           TTTTTTTTTTT
  */

  function init(metric) {
    TopToolbarFactory.setTitle(metric.title, $scope);
    if (metric.subtitle) {
      TopToolbarFactory.setTooltip(metric.subtitle, $scope);
    }
    $scope.exportXls = exportXls;
    $scope.exportDetailsXls = exportDetailsXls;
    $scope.createReport = createReport;
    $scope.subGroupBySelected = subGroupBySelected;
    $scope.graphTypeSelected = graphTypeSelected;

    $scope.metric = metric;
    $scope.queryResponse = null;

    $scope.careScenarios = [];
    $scope.surveyScenarios = [];
    $scope.marketingScenarios = [];
    $scope.scenarios = scenarios.sort((s1, s2) => s2.is_active - s1.is_active);
    $scope.scenarios.forEach(scenario => {
      switch (scenario.flavor) {
        case 'quick-replies':
          $scope.careScenarios.push(scenario);
          break;
        case 'satisfaction-survey':
          $scope.surveyScenarios.push(scenario);
          break;
        case 'campaign-scenarios':
          $scope.marketingScenarios.push(scenario);
          break;
      }
    });

    $scope.selectorsGroups = createSelectorsGroups(metric);
    $scope.selectorsGroups.maybeDisableMoreCriteriaButtons();
    $scope.selectorsGroups.maybeDisableResetAllCriteriaButtons();
    $scope.selectorsGroups.initVisibilitiesFromLocalStorage();
    $scope.selectorsGroups.load();
    $scope.selectorsGroups.saveVisibilitiesToLocalStorage(); // load might have updated the visibilities
    $scope.groupBy = createGroupBy(metric, _graphChangedCallback);

    if ($stateParams.fromReportId) {
      MetricsFactory.getReport($stateParams.companyId, $stateParams.fromReportId)
        .then(function (reportResult) {
          let selectedReport = reportResult.data;

          if (selectedReport?.id) { // report may have been deleted
            MetricsFactory.getReportDate($stateParams.companyId, $stateParams.fromReportId)
              .then(function (reportDateResult) {
                let reportDate = reportDateResult.data;
                $scope.selectorsGroups.loadFromReport(selectedReport, reportDate);
                $scope.selectorsGroups.saveVisibilitiesToLocalStorage(); // loadFromReport might have updated the visibilities
                $scope.groupBy.loadFromReport(selectedReport, reportDate);
                submitQuery();
              });
          } else {
            loadMetric();
          }
        });
    } else {
      loadMetric();
    }
  }

  function loadMetric() {
    $scope.groupBy.load();
    submitQuery();
  }

  init(metric);
}
